import { render, staticRenderFns } from "./PeriodYear.vue?vue&type=template&id=781407db&scoped=true"
import script from "./PeriodYear.vue?vue&type=script&lang=ts"
export * from "./PeriodYear.vue?vue&type=script&lang=ts"
import style0 from "./PeriodYear.vue?vue&type=style&index=0&id=781407db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781407db",
  null
  
)

export default component.exports